export const locale = {
    lang: 'pt',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': 'Perfil da empresa Web',
        'TIT_WCP_DAT': 'Dados de acesso',
        'CHAN_INF':'Carregamento de informação',
        'HELP': 'Ajuda',
        'EnlaceWCP':'Copiar link para entrar no perfil da empresa',
        'ClaveWCP':'Copiar palavra-passe para entrar no perfil da empresa',
        'PORDUC_CER':{
          '40': 'Certificado 3.0',
          '1': 'Certifique',
          '20':'Certifique 2.0',

        },
        'ESTA_WEB_CP':{
          'false': 'Eu não publico',
          'true':'Público',
        },
        'MODAL':{
          'TIT_MOD': 'Qual é a razão para não publicá-lo?',
          'BTN_CONT':'Continuar',
          'BTN_CANC': 'Cancelar',
          'RAISON_OBLIG': 'Para continuar, você deve inserir o motivo da não publicação',
          'TIT_CONDI_US': 'Termos de Utilização',
          'TEX1_CONDI_US': 'Quando o perfil da empresa é tornado público, será publicado na página Great Place To Work(r) com a informação que foi configurada. Great Place to Work(r) não é responsável pelo conteúdo, uma vez que os dados publicados são o resultado da informação que a própria empresa carregou nas plataformas destinadas a este fim.',
          'TEX2_CONDI_US': 'Também a empresa concorda que esta informação será carregada nos vários motores de busca que foram contratados para aumentar a divulgação das melhores empresas para trabalhar que foram certificadas pelo Great Place To Work(r)',
          'TEX3_CONDI_US': 'Em qualquer altura, a empresa pode devolver o perfil da empresa ao modo privado, o que a fará deixar de aparecer na lista de empresas certificadas, no entanto, Great Place To Work(r) não será capaz de remover a indexação que os motores de busca fizeram, pelo que é provável que durante algum tempo o nome da empresa continue a aparecer dentro dos resultados da pesquisa nos diferentes motores de busca com os quais Great Place To Work trabalha',
          'TEX4_CONDI_US': 'A publicação ou não publicação deste perfil de empresa é da exclusiva responsabilidade da empresa',
          'REA_TEX_CONDI_US': 'Para confirmar, escrever o seguinte texto',
          'NO_DISPO_ARCHI':'O ficheiro não está disponível',
        }

      }
    }
};
